import { filter } from 'rxjs/operators';

export const isTruly = <T>(item: T | null | undefined | false | 0): item is T =>
  Boolean(item);

export const filterTruly = filter(isTruly);
